import { Model } from "@vuex-orm/core";

export interface commentAttachmentEntity {
  documentTypeId: number;
  attachmentId: number;
  commentId: string;
  blobPath: string;
  name: string;
  isDeleted: boolean;
  isNew: boolean;
}

export class commentAttachmentEntity extends Model {
  static entity = "commentAttachmentEntity";
  static primaryKey = "attachmentId";

  static fields() {
    return {
      documentTypeId: this.number(0),
      attachmentId: this.uid(),
      commentId: this.string(""),
      blobPath: this.string(""),
      name: this.string(""),
      isDeleted: this.boolean(false),
      isNew: this.boolean(false),
    };
  }

  get extensionFile() {
    if (this.name != "") {
      const extension = this.name.slice(this.name.lastIndexOf("."));
      return (
        [".png", ".jpg", ".jpeg", ".gif", ".bitmap"].indexOf(
          extension.toLowerCase(),
        ) > -1
      );
    }
  }

  get icon() {
    let fileName: string = this.name;
    if (fileName && fileName.length > 0 && fileName.includes(".")) {
      let fileExtension: string = fileName.slice(fileName.lastIndexOf("."));
      switch (fileExtension.toLowerCase()) {
        case ".pdf":
          return "pdf01";
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
        case ".bitmap":
          return "image02";
        case ".xlsx":
        case ".xlsm":
        case ".xlsb":
        case ".xltx":
        case ".xltm":
        case ".xls":
        case ".xlt":
        case ".xml":
        case ".xlam":
        case ".xla":
        case ".xlw":
        case ".xlr":
          return "excel01";
        case ".doc":
        case ".docx":
          return "word01";
        default:
          return "attachment01";
      }
    }

    return "attachment01";
  }
}
